<template>
	<component
		:is="href ? 'a' : 'div'"
		:class="['logo-cell', 'logo-' + logoStyle, { 'logo-link': href }]"
		:href="href || null"
		:target="href ? '_blank' : null"
		:rel="href ? 'noopener noreferrer' : null"
		:aria-label="href ? `${name} article about Paydeck (opens in a new tab)` : name"
		:title="href ? `Read on ${name}` : name"
	>
		<span v-if="failed" class="logo-fallback" aria-hidden="true">{{ name }}</span>
		<img v-else :src="src" :alt="href ? '' : name" loading="lazy" referrerpolicy="no-referrer" @error="failed = true" />
		<ArrowUpRight v-if="href" class="logo-link-arrow" :size="16" :stroke-width="2.25" aria-hidden="true" />
	</component>
</template>

<script setup>
import { ref } from "vue";
import { ArrowUpRight } from "lucide-vue-next";

defineProps({ name: String, src: String, logoStyle: String, href: { type: String, default: "" } });
const failed = ref(false);
</script>
